<template>
  <div class="orders app__page">
    <keep-alive>
      <component :is="currentComponent" @switch-component="switchComponent"></component>
    </keep-alive>
  </div>
</template>

<script>
import Orders from '@/components/orders/Orders.vue';
import Order from '@/components/orders/Order.vue';

export default {
  name: 'OrdersView',
  components: {
    Orders,
    Order,
  },
  data() {
    return {
      currentComponent: 'Orders',
    };
  },
  created() {
    this.$store.dispatch('tablePagination/reset');
    this.$store.dispatch('app/setPageTitle', 'Narudžbine');
    this.$store.dispatch('orders/resetOrdersQueryParams');
    this.$store.dispatch('orders/getOrders');
  },
  methods: {
    switchComponent(componentName) {
      this.currentComponent = componentName;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
